import env from 'utils/env/env';

/**
 * Link to the numbers of one franchise (owner company) in Reporting Web
 * (LUG-048). Reporting Web is a separate application that is not deployed
 * yet, so the link is driven by the optional runtime config
 * `VITE_REPORTING_WEB_URL` and is not rendered at all while it is missing.
 * The owner is passed as `ownerSubjectId`, the same name reporting-api uses
 * for its scoping filter.
 */
export const getReportingWebOwnerUrl = (
  ownerSubjectId: string
): string | undefined => {
  const baseUrl = env?.VITE_REPORTING_WEB_URL?.trim();

  if (!baseUrl) {
    return undefined;
  }

  try {
    const url = new URL(baseUrl);
    url.searchParams.set('ownerSubjectId', ownerSubjectId);
    return url.toString();
  } catch {
    return undefined;
  }
};
